const PageSelector = require('PageSelector');

cc.Class({
    extends: cc.Component,

    properties: {
        pageViews: [cc.PageView],
        pageSelector: PageSelector,
        totalPages: 3,
    },

    onLoad () {
        this.hide();

        this.pageSelector.setData({ totalCount: this.totalPages, pageSize: 1 });
        this.pageSelector.node.on('pageUpdated', (page) => {
            this.page = page - 1;
            this.updatPage();
        }, this);
    },

    updatPage () {
        /**
         * Depracated solution, 
         * the issue is connected with the pageView content widget, which updates its position onView resize
         * to overcome the issue just remove the align left checkbox
         * no need to schedule at all
         */
        this.scheduleOnce(() => { // TODO find a better solution
            for(let i = 0; i < this.pageViews.length; i++) {
                const pW = this.pageViews[i];

                pW.scrollToPage(this.page,  0);
            }
        }, 0.03);
    },

    onClose () {
        this.node.emit('close');
    },

    onEnable () {
        this.node.active = true;
        this.pageSelector.setPage(1);
        this.page = 0;
        this.updatPage();
        this.node.getChildByName('bg').getComponent(cc.Widget).updateAlignment();
    },


    hide () {
        this.node.active = false;
    },

    onCloseClick () {
        this.node.active = false;
        this.node.emit('close');
    }
});
